var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mostrar
    ? _c(
        "div",
        { staticClass: "chat-message-artefatos mb-4" },
        [
          _c(
            "div",
            {
              staticClass:
                "chat-message-artefatos__titulo az-text-secondary az-size-12 mb-2"
            },
            [_vm._v(" Arquivos entregues nesta resposta ")]
          ),
          _vm._l(_vm.artefatos, function(artefato) {
            return _c(
              "button",
              {
                key: artefato.idObjeto,
                staticClass:
                  "chat-message-artefatos__cartao d-flex align-center az-gap-small px-3 py-2 mb-2 w-100 text-left",
                attrs: {
                  type: "button",
                  disabled: Boolean(_vm.baixando),
                  "data-test": "artefato-cartao"
                },
                on: {
                  click: function($event) {
                    return _vm.baixar(artefato)
                  }
                }
              },
              [
                _c("icon-svg", {
                  staticClass: "flex-shrink-0",
                  attrs: {
                    name: "document-text",
                    size: 16,
                    color: "var(--neutral-600)"
                  }
                }),
                _c(
                  "span",
                  {
                    staticClass:
                      "chat-message-artefatos__texto d-flex flex-column"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "chat-message-artefatos__nome az-text-primary az-size-14 font-weight-medium",
                        attrs: { "data-test": "artefato-nome" }
                      },
                      [_vm._v(_vm._s(artefato.nome))]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "az-text-secondary az-size-12 az-muted",
                        attrs: { "data-test": "artefato-detalhe" }
                      },
                      [_vm._v(" " + _vm._s(artefato.detalhe) + " ")]
                    )
                  ]
                ),
                _vm.baixando === artefato.idObjeto
                  ? _c("v-progress-circular", {
                      staticClass: "flex-shrink-0",
                      attrs: {
                        indeterminate: "",
                        size: 16,
                        width: 2,
                        color: "primary",
                        "data-test": "artefato-baixando"
                      }
                    })
                  : _c("icon-svg", {
                      staticClass: "flex-shrink-0",
                      attrs: {
                        name: "download",
                        size: 16,
                        color: "var(--neutral-600)",
                        "data-test": "artefato-icone-download"
                      }
                    })
              ],
              1
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }